import { __exports as mustacheService } from './_virtual-mustacheService.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import { __require as requireEs_string_replace } from './node_modules-core-js-modules-es.string.replace.js';
import { __require as requireEs_string_trim } from './node_modules-core-js-modules-es.string.trim.js';
import { __require as requireWeb_domCollections_iterator } from './node_modules-core-js-modules-web.dom-collections.iterator.js';
import { __require as requireDefineProperty } from './node_modules-@babel-runtime-helpers-defineProperty.js';
import { __require as requireMustache } from './node_modules-mustache-mustache.js';

var hasRequiredMustacheService;

function requireMustacheService () {
	if (hasRequiredMustacheService) return mustacheService;
	hasRequiredMustacheService = 1;

	var _interopRequireDefault = requireInteropRequireDefault();
	Object.defineProperty(mustacheService, "__esModule", {
	  value: true
	});
	mustacheService.MustacheService = void 0;
	requireEs_string_replace();
	requireEs_string_trim();
	requireWeb_domCollections_iterator();
	var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
	var Mustache = _interopRequireWildcard(requireMustache());
	function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
	function _interopRequireWildcard(e, r) { if (e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
	class MustacheService {
	  constructor() {
	    (0, _defineProperty2.default)(this, "trimUnecessarySpaces", value => {
	      return value && value.length > 0 ? value.replace(/  +/g, ' ').trim() : value;
	    });
	    (0, _defineProperty2.default)(this, "areThereTokensIn", replacedVariables => {
	      return replacedVariables.includes('{{') && replacedVariables.includes('}}');
	    });
	    (0, _defineProperty2.default)(this, "combineObjectsWithFirstObjectPreference", (htmlTemplates, mustacheVariables) => {
	      const mustacheCombinedObjects = Object.assign({}, htmlTemplates);
	      const mustacheObjectsKeys = Object.keys(mustacheCombinedObjects);
	      for (const key of Object.keys(mustacheVariables)) {
	        if (!mustacheObjectsKeys.includes(key)) {
	          mustacheCombinedObjects[key] = mustacheVariables[key];
	        }
	      }
	      return mustacheCombinedObjects;
	    });
	  }
	  replace(template, mustacheVariables) {
	    let htmlTemplates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    const mustacheobjects = this.combineObjectsWithFirstObjectPreference(htmlTemplates, mustacheVariables);
	    let replacedTemplates = Mustache.render(template, mustacheobjects);
	    if (this.areThereTokensIn(replacedTemplates)) {
	      replacedTemplates = this.replace(replacedTemplates, mustacheVariables);
	    }
	    return this.trimUnecessarySpaces(replacedTemplates);
	  }
	}
	mustacheService.MustacheService = MustacheService;
	
	return mustacheService;
}

export { requireMustacheService as __require };
//# sourceMappingURL=vp-js-token-engine-build-services-mustacheService.js.map
